<section class="service-intro content-wrapper">
  <div class="service-content">
    <h1 class="title">
      Custom Website Design & Development Services — Goa to Global
    </h1>
    <p class="description">
      Geekeno offers expert website development services in Goa, helping
      businesses across India and globally build fast, mobile-friendly, and
      SEO-optimized websites. From WordPress and eCommerce platforms to custom
      landing pages and web applications, we deliver digital experiences that
      convert visitors into customers.
    </p>
  </div>
  <div class="decorative-elements is-hidden-touch">
    <img
      src="/assets/services/deco-element.png"
      loading="eager"
      fetchpriority="high"
      width="265"
      height="400"
      alt=""
      role="presentation"
    />
  </div>
</section>

<section class="services">
  <div class="service-divider"></div>
  <div class="service-row content-wrapper">
    <div class="service-image">
      <img
        src="/assets/services/website-development/wordpress-ecommerce.webp"
        loading="eager"
        fetchpriority="high"
        width="445"
        height="431"
        alt="Custom website developmemnt for Goa businesses"
        role="presentation"
      />
    </div>
    <div class="service-content">
      <h2 class="service-title">WordPress / ECommerce Website Development</h2>
      <p class="service-description">
        We specialize in WordPress development and custom eCommerce websites
        that are scalable, secure, and optimized for search engines. Whether
        you're launching a local business or selling globally, we build
        platforms that drive sales and reflect your brand.
      </p>
    </div>
  </div>
  <div class="service-divider"></div>
  <div class="service-row reverse content-wrapper">
    <div class="service-image">
      <img
        src="/assets/services/website-development/landing-page.avif"
        loading="lazy"
        width="445"
        height="431"
        alt="landing page"
        role="presentation"
      />
    </div>
    <div class="service-content">
      <h2 class="service-title">High-Impact Landing Pages</h2>
      <p class="service-description">
        Our landing page development focuses on speed, clarity, and conversion.
        Ideal for product launches, ad campaigns, and lead generation — each
        page is designed to guide users toward action.
      </p>
    </div>
  </div>

  <div class="service-divider"></div>
  <div class="service-row content-wrapper">
    <div class="service-image">
      <img
        src="/assets/services/website-development/mobile-app-development.webp"
        loading="lazy"
        width="445"
        height="431"
        alt="Mobile app UI design for eCommerce platform"
        role="presentation"
      />
    </div>
    <div class="service-content">
      <h2 class="service-title">Mobile App Development</h2>
      <p class="service-description">
        Geekeno builds intuitive, scalable mobile apps for iOS and Android,
        tailored to your business goals. From concept to deployment, we deliver
        apps that engage users and scale with your growth.
      </p>
    </div>
  </div>

  <div class="service-divider"></div>
  <div class="service-row reverse content-wrapper">
    <div class="service-image">
      <img
        src="/assets/services/website-development/software-development.webp"
        loading="lazy"
        width="445"
        height="431"
        alt="software development"
        role="presentation"
      />
    </div>
    <div class="service-content">
      <h2 class="service-title">Custom Software Development</h2>
      <p class="service-description">
        Our software development services include custom web apps, internal
        tools, and enterprise platforms. We focus on usability, scalability, and
        security — helping businesses streamline operations and innovate faster.
      </p>
    </div>
  </div>

  <div class="service-divider"></div>
  <div class="service-row content-wrapper">
    <div class="service-image">
      <img
        src="/assets/services/website-development/uiux.webp"
        loading="lazy"
        width="445"
        height="431"
        alt="UI/UX design"
        role="presentation"
      />
    </div>
    <div class="service-content">
      <h2 class="service-title">UI/UX Design Excellence</h2>
      <p class="service-description">
        We design intuitive interfaces and seamless user journeys that elevate
        your digital products. Our remote-ready UI/UX design ensures your
        website or app is easy to navigate, visually compelling, and
        mobile-ready.
      </p>
    </div>
  </div>

  <div class="service-divider"></div>
</section>
